import { Box } from '@mui/material';
import React from 'react';
import CAppFilterSelect from '../../../../../../../app/components/CAppFilterSelect';
import IFund from '../../../../../interfaces/fund/IFund';
import IInvestExpertiseFilters from '../../../../../interfaces/expertise/IInvestExpertiseFilters';
import { useTranslation } from 'react-i18next';

type CFiltersFundSelectProps = {
	allFunds: IFund[];
	filterFunds: IFund[];
	filters: IInvestExpertiseFilters;
	getFilterFundsForField: (field: string) => IFund[];
	onChange: (filters: IInvestExpertiseFilters) => void;
	label: string;
	multipleRenderLabelLangTag: string;
};

const CFiltersFundSelect = (props: CFiltersFundSelectProps) => {
	const { allFunds, filterFunds, filters, getFilterFundsForField, onChange, label, multipleRenderLabelLangTag } =
		props;

	const { t } = useTranslation();

	return (
		<CAppFilterSelect
			className="filter-fund"
			multiple
			multipleRenderTags={(val: IFund[]) => (
				<Box style={{ paddingLeft: '5px', fontSize: '0.85rem' }}>
					{t(multipleRenderLabelLangTag, { count: val ? val.length : 0 })}
				</Box>
			)}
			value={
				allFunds
					? allFunds.filter((x) => filters && filters.fundIds && filters.fundIds.includes(x.id)).length > 0
						? allFunds.filter((x) => filters && filters.fundIds && filters.fundIds.includes(x.id))
						: allFunds.filter((x) =>
								getFilterFundsForField('fundIds')
									.map((f) => f.id)
									.includes(x.id),
						  )
					: null
			}
			onChange={(val: IFund[]) =>
				onChange({
					...filters,
					fundIds: val && val.length > 0 ? val.map((x) => x.id) : null,
				})
			}
			label={label}
			size="small"
			options={
				filterFunds
					? getFilterFundsForField('fundIds').map((x: IFund) => ({
							id: x.id,
							name: x.name,
							color: x.isRealized ? '#8799B4' : null,
					  }))
					: null
			}
		/>
	);
};

export default CFiltersFundSelect;
